import { useQuery } from 'react-query';
import useAbortController from 'hooks/useAbortController';
import { getApplicationStatuses } from 'services/applicationStatus';

const useApplicationStatusQuery = ({ options } = {}) => {
  const abortControllerOptions = useAbortController();
  const queryKey = ['getApplicationStatuses'];

  return useQuery(
    queryKey,
    () => getApplicationStatuses(abortControllerOptions),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchOnSettled: false,
      retry: false,
      ...options,
    },
  );
};

export default useApplicationStatusQuery;
